import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import BlockList from './block-list';
import { SVGPureIcon } from '@/ui';
import appLogger from "@public/log/monitor";
import userStore from '@/store/user';
import CreateBtn from './create-btn';
import BackBtn from './back-btn';
import agentPageStore from '../store';
import createMcpStore from '@/pages/agent-create/store'
import EE from '@/common/event';
import ScrollView from '@/ui/scroll-view';

const MyAgent = observer(() => {
  useEffect(() => {
    agentPageStore.getMyAgent();
    createMcpStore.loadMCPlist() // 提前加载

    EE.on('AIAgentEdit', agentPageStore.getMyAgent);

    appLogger.log({
      key: 'aibot_agent',
      action: 'show',
      page: 'my_agent',
    });

    return () => {
      EE.off('AIAgentEdit', agentPageStore.getMyAgent);
    };
  }, []);

  return (
    <div className="w-full h-full flex flex-col px-4px ">
      <div className="h-72px w-full py-20px px-20px flex z-9">
        <BackBtn />
        <div className="flex items-center ml-auto">
          {userStore.isUser ? <CreateBtn /> : null}
        </div>
      </div>
      <ScrollView className="w-full h-0 flex-grow">
        <div className="w-768px mx-auto pb-20px">
          {agentPageStore.loadedMine && !agentPageStore.myAgentList.length ? (
            <>
              <div
                onClick={evt => {
                  agentPageStore.gotoCreate();
                }}
                className={[
                  'flex items-center w-376px h-118px px-16px rounded-20px cursor-pointer',
                  'hover:bg-[rgba(0,0,0,0.03)]',
                  '',
                ]}
              >
                <div className="size-64px vh-center border-1px border-dashed border-[rgba(0,0,0,0.1)] mr-12px rounded-full overflow-hidden">
                  <SVGPureIcon name="add_agent" className="size-20px" />
                </div>

                <div className="flex-grow w-0">
                  <div className="text-16px text-black font-bold leading-22px mb-2px">
                    创建智能体
                  </div>
                  <div className="text-12px text-black leading-17px my-4px line-clamp-2">
                    根据您的需求，创建可以完成指定任务的智能体
                  </div>
                </div>
              </div>
            </>
          ) : (
            <BlockList
              isMine={true}
              showMenu={true}
              list={agentPageStore.myAgentList}
            />
          )}
        </div>
      </ScrollView>
    </div>
  );
});

export default MyAgent;
